@if(showPopup){
<app-event-popup (closed)="showPopup = false"></app-event-popup>
}

<!-- Hero Section -->
<section class="hero-section">
  <div class="hero-overlay"></div>

  <div class="hero-content">
    <h1 class="hero-title animate-hero-title">
      Consultoría<br>
      Financiera Estratégica
    </h1>
    <p class="hero-subtitle animate-hero-subtitle">
      Para individuos, PyMEs, estudios contables y empresas que buscan tomar mejores decisiones,
      acceder a financiamiento o hacer crecer su patrimonio.
    </p>
  </div>
</section>

<!-- Barra amarilla -->
<div class="hero-bottom-bar animate-hero-bar">
  <p class="hero-services">
    Financiamiento PyME | External CFO | Tesorería & COMEX
  </p>
</div>

<app-about-us></app-about-us>
<app-our-services></app-our-services>
<app-partners></app-partners>
<app-newsletter></app-newsletter>
<app-cta-section></app-cta-section>